import appLogger from "../../infra/logger/appLogger";
import platformClipboard from "./platformClipboard";
export default class ClientClipboard {
    platformClipboard;
    moduleLogger;
    constructor() {
        this.platformClipboard = platformClipboard;
        this.moduleLogger = appLogger.withTag("clientClipboard");
    }
    async writeText(text) {
        const trimmedText = text.trim();
        if (!trimmedText) {
            throw new Error("clientClipboard: nothing to copy (empty or whitespace-only text)");
        }
        await this.platformClipboard.writeText(trimmedText);
    }
    defaultCatch = (writeError) => {
        this.moduleLogger.error(`writeText failed via the ${this.platformClipboard.adapterName} adapter`, writeError);
    };
}
